import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleScreenOnly: IAbstractModule = {
  type: IModuleType.screenOnly,
  name: 'Master 0 (screen only/totem)',
  hasScreen: true,
  columns: [
    [
      // we need dummy compartments so code doesn't end up in an endless loop
      {
        name: "DUMMY15",
        connector: "15",
        cell_size_id: 4,
        accessible: false,
      },
      {
        name: "DUMMY16",
        connector: "16",
        cell_size_id: 4,
        accessible: false,
      },
      {
        name: "DUMMY18",
        connector: "18",
        cell_size_id: 4,
        accessible: false,
      },
    ],
  ]
};
